import { useParams, Link } from 'react-router-dom';
import { useApi } from '../hooks/useApi.js';
import { getVirtualProduct } from '../api/virtualApi.js';
import VirtualDetail from './VirtualDetail.jsx';
import './VirtualDetailPage.css';

function VirtualDetailPage() {
  const { id } = useParams();
  const { data: product, loading } = useApi(() => getVirtualProduct(id), [id]);

  if (loading) {
    return <main className="vd"><div className="vd-loading">載入中…</div></main>;
  }
  if (!product) {
    return (
      <main className="vd">
        <p className="vd-empty">找不到此虛擬商品。<Link to="/virtual">返回虛擬商品</Link></p>
      </main>
    );
  }

  return <VirtualDetail product={product} />;
}

export default VirtualDetailPage;
